var React = require('react');

function HighGrowthIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M141.119 117.663v-87.15h-21.246v101.165a130.67 130.67 0 0 1-7.518 3.587V94.888H91.11v47.911a183.06 183.06 0 0 1-7.519 1.918V51.746H62.346v96.671c-2.487.299-4.991.558-7.518.773V78.458H33.582v71.544a250.701 250.701 0 0 1-21.228-1.049 3.745 3.745 0 0 0-4.067 3.395 3.744 3.744 0 0 0 3.396 4.066c41.714 3.825 82.146-2.464 112.886-18.718 25.612-13.548 44.539-33.97 52.052-61.196l2.144 3.604a3.74 3.74 0 1 0 6.429-3.823l-6.785-11.388c-1.072-2.306-3.925-2.814-5.764-1.348l-10.84 7.987a3.754 3.754 0 0 0-.807 5.245 3.755 3.755 0 0 0 5.245.806l2.854-2.097c-4.884 16.926-14.692 30.998-27.981 42.182l.003-.005Z"}));
}

HighGrowthIconInline.defaultProps = {"className":"fill-current","viewBox":"0 0 200 160"};

module.exports = HighGrowthIconInline;

HighGrowthIconInline.default = HighGrowthIconInline;
